export default {
    en: {
        req: 'required',
        amount_send: 'Amount and currency',
        amount: 'Amount',
        sender_name: 'Sender (you)',
        name_send: `Beneficiary's full name`,
        name_placeholder: `John Wick`,
        phone_number: `Beneficiary's phone number`,
        card_number: `Beneficiary's card number`,
        account_send: `Beneficiary's account number`,
        fullname: 'Full name',
        telegram: 'Telegram nickname',
        telegram_placeholder: 'nickname',
        upi_id_placeholder: 'UPI ID',
        account_number: 'Account number',
        network_list: 'Select network',
        wallet_address_send: 'Beneficiary wallet address',
        swift_code: 'SWIFT/BIC code',
        iban_number: 'IBAN number',
        bank_name: 'Bank name',
        upi_id: 'UPI ID',
        address: 'Аddress',
        city: 'City',
        country: 'Country',
        file: 'Recipient file',
        file_formats: 'Supported formats: jpg, jpeg, png, gif, pdf',
    },
    ru: {
        req: 'обяз',
        amount_send: 'Сумма и валюта отправления',
        amount: 'Сумма',
        sender_name: 'Отправитель (вы)',
        name_send: `Имя и фамилия получателя`,
        name_placeholder: 'Ivan Petrov',
        phone_number: `Номер телефона получателя`,
        card_number: `Номер карты получателя`,
        account_send: `Номер счета получателя`,
        fullname: 'Имя получателя',
        telegram: 'Телеграм ник',
        telegram_placeholder: "Ваш никнейм в телеграме",
        upi_id_placeholder: 'UPI ID',
        account_number: 'Номер счета',
        network_list: 'Выберите сеть',
        wallet_address_send: 'Адрес кошелька получателя',
        swift_code: 'SWIFT/BIC код',
        iban_number: 'IBAN номер',
        bank_name: 'Название банка',
        upi_id: 'UPI ID',
        address: 'Адрес',
        city: 'Город',
        country: 'Страна',
        file: 'Файл получателя',
        file_formats: 'Поддерживаемые форматы: jpg, jpeg, png, gif, pdf',
    }
}